import { render, staticRenderFns } from "./selectGoods.vue?vue&type=template&id=62f13221&scoped=true"
import script from "./selectGoods.vue?vue&type=script&lang=ts"
export * from "./selectGoods.vue?vue&type=script&lang=ts"
import style0 from "./selectGoods.vue?vue&type=style&index=0&id=62f13221&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f13221",
  null
  
)

export default component.exports